import { render, staticRenderFns } from "./BackendUpgradeSessionSingle.vue?vue&type=template&id=187cbd37&scoped=true&lang=pug"
import script from "./BackendUpgradeSessionSingle.vue?vue&type=script&lang=js"
export * from "./BackendUpgradeSessionSingle.vue?vue&type=script&lang=js"
import style0 from "./BackendUpgradeSessionSingle.vue?vue&type=style&index=0&id=187cbd37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187cbd37",
  null
  
)

export default component.exports